import { Badge } from "@mantine/core";
import { bowColorHex, type OrnamentModel, type PillowModel } from "../../types/api";
import type { ModelPresenter } from "./presenter";

export const pillowPresenter: ModelPresenter<PillowModel> = {
  thumb: (m) => ({ src: m.previewUrl, tint: m.color, label: m.color }),
  downloads: (m) => (m.printUrl === null ? [] : [{ label: "Print", url: m.printUrl }]),
  badges: (m) =>
    m.printId === null ? null : (
      <Badge variant="dot" size="xs" color="teal">
        Print ready
      </Badge>
    ),
};

export const ornamentVariantLabel = (m: OrnamentModel) => `${m.bowColor} · ${m.backgroundRemoved ? "cut-out" : "full photo"}`;

export const ornamentPresenter: ModelPresenter<OrnamentModel> = {
  thumb: (m) => ({ src: m.photoUrl, tint: bowColorHex(m.bowColor), label: ornamentVariantLabel(m) }),
  downloads: (m) => [{ label: "Photo", url: m.photoUrl }],
  badges: (m) => (
    <Badge variant="light" size="xs" color={m.backgroundRemoved ? "teal" : "gray"}>
      {m.backgroundRemoved ? "Background removed" : "Full photo"}
    </Badge>
  ),
};
